<template>
  <validation-observer ref="form">
    <SectionTitle
        :has-line="true"
        :content="positionName"
        container-class="mb-4"
      />
    <div class="row ml-2  pt-3 bg-secondary-3 row-container pb-3 pl-3">
      <div class="col-md-2 col-sm-12 ">
        <label>Puesto:</label>
        <p class="font-weight-bold">
          {{ positionName }}
        </p>
      </div>
      <div class="col-md-2 col-sm-12 mt-1">
        <label>Nombre:</label>
        <p class="font-weight-bold">
          {{ fullName }}
        </p>
      </div>
      <div class="col-md-3 col-sm-12 mt-1">
        <ValidationProvider
          v-slot="{ errors }"
          :rules="`${validationTriggered ? 'required' : ''}`"
        >
          <CustomDropDown
            id="input-type"
            v-model="model.type"
            label="Tipo de Firma:"
            placeholder="Tipo de Firma"
            fieldkey="id"
            fieldname="name"
            :options="types"
            :error="errors[0]"
            :disabled="disableSignatureTypeDropdown"
            custom-error-msg="El tipo de firma es requerido."
          />
        </ValidationProvider>
        <error
          v-if="
            allSignaturesMustBeElectronic &&
              validationTriggered &&
              !justSaveTab10
          "
          variant="no-border"
          message="Todas las firmas deben ser firma electrónica."
        />
      </div>
      <div v-if="showInputEmail" class="col-md-4 col-sm-12 mt-1">
        <ValidationProvider
          v-slot="{ errors }"
          :rules="`required|email|mustBeEmailSelection:${searchEmailSnapshot.input}`"
          name="emailSelection"
          mode="eager"
          :custom-messages="{
            required: 'El correo electrónico es requerido.',
            email: 'El correo electrónico no es válido.',
            mustBeEmailSelection: 'El correo electrónico no es válido.'
          }"
        >
          <label>Correo Electrónico:</label>
          <div v-if="searchEmailSnapshot.data.length>0 && showResults" class="search-results">
              <div v-for="(item, index) in searchEmailSnapshot.data" :key="index" class="ml-2 mt-2">
                  <div @click="selectOption(item.email)">
                    <div class="color-black font-14 font-weight-bold">
                    {{ item.fullName | capitalize }}
                  </div>
                  <div class="color-gray-6 font-14 font-italic">
                    {{ item.userName }} / {{ item.email }}
                  </div>
                  <div class="division"></div>
                </div>
              </div>
          </div>
          <div class="row">
            <div class="col-11">
              <custom-input
                ref="customInput" 
                v-model="searchEmailSnapshot.input"
                placeholder="Escriba correo electrónico"
                icon= "fa fa-search orange-icon"
                :leftIcon="true"
                :disabled="inputEmailIsdisabled || disableEmailInput"
                :error="errors[0]&& validate"
                :custom-error-msg.sync="errors[0]"
                @input="onChangeEmail"
                @blur="blur"
              />
            </div>
            <div class="col-1">
              <ActionButton
                  v-if="searchEmailSnapshot?.input"
                  type="button"
                  :disabled="inputEmailIsdisabled"
                  i="fa fa fa-search "
                  variant="success"
                  class="ml-2 alignButton"
                  @click="searchHandler(searchEmailSnapshot.input)"
                />
            </div>
          </div>
        </ValidationProvider>
        <br>
      </div>
      <div class="col-12" v-if="isElectronicSign">
        <div class="container-list mt-4">
           <Error
              v-if="itemsUsers.length > 1"
              is-alert-mode
              class="m-3"
              message="Se ha reportado mas de 1 cuenta para este rol. Por favor selecciona una."
            />

          <div v-if="canShowListUser && itemsUsers.length">
            <div
              class="row m-3 bg-secondary-3 row-container pt-3"
              v-for="(item, index) in itemsUsers"
              :key="index"
            >
              <div class="col-md-1 mt-2">
                <div class="form-check mt-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    :id="'radio-' + index"
                    :name="'items-radio'+ positionCode "
                    :value="item.userId"
                    v-model="selectedItemId"
                    @change="handleRadioChange(item)"
                  />
                </div>
              </div>
              <div class="col-md-3 col-sm-12 mt-1">
                <label>Nombre:</label>
                <p class="font-weight-bold">
                  {{ item.fullname }}
                </p>
              </div>
              <div class="col-md-3 col-sm-12 mt-1">
                <label>Usuario/Correo Electrónico:</label>
                <p class="font-weight-bold">
                {{ item.username }} / {{ item.email }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="canShowSelectCurrentUser"
            class="row m-3 bg-secondary-3 row-container"
          >
            <div class="col-md-1 mt-2">
              <div class="form-check">
                <input
                  class="form-check-input mt-3"
                  type="radio"
                  :id="'radio-auto-sign'+ positionCode"
                  :name="'items-radio'+positionCode"
                  :value="0"
                  v-model="selectedItemId"
                  @change="handleRadioChangeActualUser()"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-12 mt-1 pb-3">
              <p class="font-weight-bold mt-3">
                Asignarme como firmante
              </p>
            </div>
          </div>
          <div
            class="row m-3 bg-secondary-3 row-container"
          >
            <div class="col-md-1 mt-2">
              <div class="form-check">
                <input
                  class="form-check-input mt-3"
                  type="radio"
                  :id="'radio-otro'+ positionCode"
                  :name="'items-radio'+positionCode"
                  :value="1"
                  v-model="selectedItemId"
                  @change="handleRadioChangeOthers()"
                />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 mt-1 pb-3">
              
              <p class="font-weight-bold mt-3">
                Deseo firmar con otra cuenta. Si no se encuentra una cuenta asociada al correo electrónico seleccionado, se creara una nueva cuenta.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </validation-observer>
</template>

<script>
import ActionButton from "ActionButton";
import CustomInput from "@/components/common/CustomInput";
import Error from "custom-error";
import CustomDropDown from "custom-drop-down";
import { CustomAutoComplete } from "@/components/common";
import { SignatureTypes } from "@/utils/constants/signature/signatureTypes";
import PermissionsNames from "@/utils/constants/permissions.js";
import { searchUserEmail as _searchUserEmail } from "@/modules/user/api";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { SectionTitle } from '@/components/pei/shared';
import generalService from '@/services/pei/general';
import store from "@/store/index";

const REPRESENTANTE_FAMILIA = [174,171,235]
const REPRESENTANTE_EDU_SPEC = [453, 238]
const DEPRESENTANTE_DEPR = [236,826];
const DIRECTOR_ESCOLAR = 236;

extend("mustBeEmailSelection", {
  validate: (value, { selectedEmail }) => {
    return selectedEmail === value;
  },
  params: ["selectedEmail"]
});
export default {
  name: "Tab10ParticipantSignaturesRow",
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    originalSignatureTypeId:{
      type: Number,
      default: null
    },
    originalEmail:{
      type: String,
      default: null
    },
    positionName: {
      type: String,
      default: null
    },
    fullName: {
      type: String,
      default: null
    },
    options: {
      type: Array,
      default: () => []
    },
    signatureTypes: {
      type: Array,
      default: () => []
    },
    showOption: {
      type: Boolean,
      default: false
    },
    allSignaturesMustBeElectronic: {
      type: Boolean,
      default: false
    },
    atLeastOneIsElectronic: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    schoolId:{
      type: Number,
      default: null
    },
    positionCode: {
      type: Number,
      default: null
    }   
  },
  components: {
    CustomInput,
    CustomDropDown,
    ActionButton,
    ValidationObserver,
    ValidationProvider,
    CustomAutoComplete,
    Error,
    SectionTitle
  },
  data() {
    return {
      isRequiredValidation: true,
      pasedOptions: [],
      searchEmailSnapshot: {
        input: this.value.email,
        data: []
      },
      firstRun: true,
      itemsUsers: [],
      showResults:false,
      selectedItemId:null,
      profileUser: store.getters['$_user/fullProfile'],
      inputEmailIsdisabled: true,
      finalSchoolId:null
    };
  },
  async mounted() {
    this.$refs.form?.reset();
    if (!this.canShowElectronicSignature) {
      this.model.type = this.types[0];
    } else {
      const type = this.signatureTypes?.find(e => e.id === this.model.typeId);
      this.model.type = type;
    }

    if(this.model.email == this.userProfile.email) {
      this.selectedItemId = 0; //Asignarme como firmante
    }   
    else if(this.model.email){
      this.inputEmailIsdisabled = false;
      this.selectedItemId = 1; //Deseo firmar con otra cuenta
    }              
  },
  methods: {
    handleSubmit(val) {
      this.model = {
        ...this.model,
        ...val
      };      
      this.searchEmailSnapshot.input = val.email;
    },
    handleOnChange(val) {      
      this.model.email = val;
      if (!val) {
        this.searchEmailSnapshot.input = null;
      }
    },
    onChangeEmail(val){      
      this.model.email = val
    },
    getResultValue(result) {
      return result.email;
    },
    handleRadioChange(item){
      this.searchEmailSnapshot.input =  null;
      this.selectedItemId = item.email;
      this.searchEmailSnapshot.input =  this.selectedItemId;
      this.inputEmailIsdisabled = true;
      this.selectOption(this.searchEmailSnapshot.input);
    },
    handleRadioChangeOthers(item){
      this.searchEmailSnapshot.input =  null;
      this.inputEmailIsdisabled = false;
      this.selectOption(this.searchEmailSnapshot.input);
    },
    handleRadioChangeActualUser(item){
      this.selectedItemId = this.profileUser.email;
      this.searchEmailSnapshot.input =  this.selectedItemId;
      this.inputEmailIsdisabled = true;
      this.selectOption(this.searchEmailSnapshot.input);
    },
    selectOption(option){      
      this.searchEmailSnapshot.input = option
      this.handleOnChange(option);
      this.showResults = false;
    },
    focus(e){
      this.showResults = true;
      this.$nextTick(() => { });
    },
    async blur(e){
      await new Promise((resolve) => setTimeout(resolve, 250));
      this.showResults = false;
      this.$nextTick(() => { });   
    },
    async getData(param){
      const { data } = await generalService.getListUsertoSign(param);
      return data;
    },
    searchHandler(input) {
      if(this.inputEmailIsdisabled){
        return;
      }
      return new Promise(resolve => {
        this.searchEmailSnapshot.input = input;
        _searchUserEmail({ name: input }).then(({ data: response }) => {
          this.searchEmailSnapshot.data = response.data.map(item => ({
            ...item,
            fullName: this.$options.filters.capitalize(item.fullName)
          }));
          this.showResults = this.searchEmailSnapshot.data.length > 0
          this.$refs.customInput.focus(); 
          resolve(this.searchEmailSnapshot.data);
        });
      });
    }
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    justSaveTab10() {
      return this.$store.getters.justSaveTab10;
    },
    isEspecia(){
      return REPRESENTANTE_EDU_SPEC.some(x => x == this.positionCode);   
    },
    isDeprRepresentative(){
      return DEPRESENTANTE_DEPR.some(x => x == this.positionCode);
    },
    isFamilyRepresentative(){
      return REPRESENTANTE_FAMILIA.some(x => x == this.positionCode);
    },
    isDirector(){
      return DIRECTOR_ESCOLAR == this.positionCode;
    },
    isElectronicSign(){
      return this.model.type?.id == SignatureTypes.email;
    },
    canShowListUser(){
      return this.isFamilyRepresentative || this.isDirector;
    },
    canShowSelectCurrentUser(){
      return this.isEspecia  && !this.isDirector;
    },
    showInputEmail() {
      return this.model.type?.id === SignatureTypes.email;
    },
    canShowElectronicSignature() {      
      return this.userHasPermissions(
        PermissionsNames.optionelectronicsignature
      ); 
    },
    disableSignatureTypeDropdown() {
      return this.disabled || this.types.length == 1;
    },
    disableEmailInput() {
      return this.disableSignatureTypeDropdown && this.originalEmail?.length > 0;
    },
    // This is to check if the signature is electronic already got from db
    isElectronicFromDb(){
      return this.originalSignatureTypeId === SignatureTypes.email;
    },
    types() {
      let availableTypes = [SignatureTypes.email, SignatureTypes.manual];

      let result = this.signatureTypes.filter(x =>
        availableTypes.includes(x.id)
      );      

      if (!this.canShowElectronicSignature) {
        result = result.filter(x => x.id !== SignatureTypes.email);
      }     

      if (result.length === 1) {
        this.model.type = result[0];
      }

      return result;
    },
    validationTriggered() {
      return this.validate;
    }
  },
  watch: {
    atLeastOneIsElectronic: {
      handler: function(newValue) {
        if (newValue) {
          const type = this.types?.find(e => e.id == SignatureTypes.email);
          this.model.type = type;
        }
      },
      immediate: true
    },
    value: {
      deep: true,
      handler(newValue) {
        if (!newValue?.id) return;
        this.model.type = { ...newValue };
      }
    },
    "model.type": {
      handler(newValue) {
        if (this.disabled) {
          return;
        }
        this.$emit("update-signature-type", newValue);
      },
      immediate: false
    },
    schoolId:{
      handler: async function(newValue) {
        if (newValue) {
         this.finalSchoolId = newValue;
         let selectedStudent = store.getters.SelectedStudent;
          if(this.isFamilyRepresentative || this.isDirector)
          {
            let param = {
              studentSieId: selectedStudent.studentId,
              isParent: this.isFamilyRepresentative,
              schoolId: this.schoolId
            }
            this.itemsUsers = await this.getData(param);

            if(this.itemsUsers.find(c=> c.email == this.model.email) != null) {
              this.selectedItemId = this.itemsUsers.find(c=> c.email == this.model.email)?.userId;
            }
          }
        }
      },
      immediate: true
    },
  }
};
</script>
<style scoped lang="scss">
.dot {
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #fff 0 0 no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
}
.text-red {
  color: #c9545e;
}
.text-center {
  text-align: center;
}
.drop-item {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.drop-item:hover {
  text-decoration: none;
  color: #727272;
}

.dropdown-item {
  font: Bold 16px/19px Lato;
}

.divider-horizontal {
  border: 0.5px solid #e2e2e2;
  position: relative;
  top: 12px;
  width: 90%;
}
.orange-icon {
  color: #ff7058;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: "Lato", sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  display: block;
  width: 100%;
}
.dropdown-menu-width {
  width: 91%;
}
@media (min-width: 992px) {
  .btn-dropdown-actions {
    /* width: 4.5rem; */
    font-size: 0.7rem;
    margin-right: 0px;
    display: block;
    width: 100%;
  }
}

@media (min-width: 1200px) and (max-width: 1440px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    margin-right: -8px;
  }
}

@media (min-width: 1440px) and (max-width: 1920px) {
  .btn-dropdown-actions {
    font-size: 0.9rem;
    /* width: 7.4375rem; */
  }
}
.input-label {
  font: Bold 0.825rem Lato !important;
}
.row-container{
  border-radius: 7px;
}
.container-list{
  background-color: white;
  margin: 5px;
  padding: 1px;
  border-radius: 5px;
}
label{
  color:gray
}
input[type="radio"] {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #d3d3d3;
  border-radius: 50%;
  background-color: #f5f5f5;
  transition: background-color 0.3s ease, border-color 0.3s ease;
  cursor: pointer;

  &:checked {
    background-color: #2eb782;
    border-color: #3b3b3b;
  }

  &:hover {
    border-color: #a9a9a9;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(46, 183, 130, 0.5);
  }
}

.form-check-input {
  width: 20px;
  height: 20px;
  accent-color: #2eb782;
  
  border-radius: 50%;
  border: 5px solid lightgray;
  border-color: lightgray;
}


.form-check-input:checked {
  border: 5px solid lightgray; 
  background-color: white !important;
  border-color: #2eb782 !important; 
}


.form-check-input:not(:checked) {
  background-color: white; 
}


.form-check-input:not(:checked) {
  border-color: lightgray;
}


.font-weight-bold {
  font-weight: bold;
}
.search-container {
  position: relative;
}

.search-results {
  position: absolute;
  top: 88%;
  left: 15px;
  width: 95%;
  max-height: 200px;
  overflow-y: auto;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  z-index: 10;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
}

.search-results ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.search-results li {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.search-results li:hover {
  background-color: #f1f1f1;
}
.division{
  height: 1px;
  background-color: darkgray;
}
.alignButton{
  position: relative;
  left: -27px;
}
</style>
